import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Grid } from "@mui/material";
import { useContext, useEffect } from "react";
import { ProviderProjectDashboard } from "../ProjectSupportDashboard";

const ChartSectionMedia = () => {

    const {
        lstMediaChart,
    } = useContext(ProviderProjectDashboard);

    useEffect(() => {
        ChartSectionMedia();
    }, [lstMediaChart])

    const ChartSectionMedia = () => {

        am4core.addLicense("CH208466903"); //รหัสรายเส้นใช้ไม่ให้ขึ้นเส้นโลโก้
        let chart = am4core.create("ChartSectionMedia", am4charts.XYChart);

        chart.colors.list = [
            am4core.color("#0097b2"),
            am4core.color("#fb954e"),
            am4core.color("#7ed957"),
        ];

        const arrData = lstMediaChart.map((item) => {
            let resultData = {
                "year": item.sYear,
                "DigitalMedia": item.nDigitalMedia,
                "PrintMedia": item.nPrintMedia,
                "Presentation": item.nPresentation
            };
            return resultData;
        });
        chart.data = arrData

        // chart.data = [
        //     {
        //         "year": "2565",
        //         "DigitalMedia": 45,
        //         "PrintMedia": 40,
        //         "Presentation": 30
        //     },
        //     {
        //         "year": "2566",
        //         "DigitalMedia": 35,
        //         "PrintMedia": 20,
        //         "Presentation": 30
        //     },
        //     {
        //         "year": "2567",
        //         "DigitalMedia": 5,
        //         "PrintMedia": 48,
        //         "Presentation": 35
        //     }]

        // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "year";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 20;
        // categoryAxis.renderer.cellStartLocation = 0.1;
        // categoryAxis.renderer.cellEndLocation = 0.9;
        //categoryAxis.renderer.grid.template.disabled = true;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.extraMax = 0.1; 
        valueAxis.numberFormatter.numberFormat = '#,###'
        valueAxis.strictMinMax = true;
        valueAxis.calculateTotals = true;
        
        // Create series
        function createSeries(field, name, stacked) {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "year";
            series.name = name;
            series.columns.template.tooltipText = "{name}: [bold]{valueY}[/] โครงการ";
            series.stacked = stacked;
            series.columns.template.width = am4core.percent(50);

            let bullet = series.bullets.push(new am4charts.LabelBullet())
            bullet.interactionsEnabled = false
            bullet.dy = 20;
            bullet.label.text = '{valueY}'
            bullet.label.fill = am4core.color('#ffffff')
        }

        createSeries("DigitalMedia", "สื่อดิจิทัลเพื่อการเผยแพร่ ประชาสัมพันธ์ และนำเสนอผลงานโครงการให้กลุ่มเป้าหมาย/สาธารณชน", false);
        createSeries("PrintMedia", "สื่อสิ่งพิมพ์เพื่อการเผยแพร่ ประชาสัมพันธ์ และนำเสนอผลงานโครงการให้กลุ่มเป้าหมาย/สาธารณชน", false);
        createSeries("Presentation", "การนำเสนอผลงานโครงการผ่านการประชุม/สัมมนาของหน่วยงานและ/หรือภายนอกหน่วยงาน", false);

        // Add legend
        chart.legend = new am4charts.Legend()
        chart.legend.position = 'top'
        chart.legend.paddingBottom = 20
        chart.legend.labels.template.maxWidth = 100

    }
    return (
        <>
            <Grid item xs={12} md={12}>
                <div id="ChartSectionMedia" style={{ width: "100%", height: "570px" }}></div>
            </Grid>
        </>
    )
}
export default ChartSectionMedia